import React from "react";
import cx from "classnames";
import { pages, locations } from "../../constants";
import { slugify } from "../../helpers";
import { Link } from "react-router-dom";
import SocialIcons from "../SocialIcons";
import styles from "./styles.module.sass";

const PUBLIC_URL = process.env.PUBLIC_URL ?? "";

const GlobalNav: React.FC = () => {
  return (
    <div className={styles.menu}>
      <div className={styles.item}>The Collection</div>
      <ul className={styles.list}>
        {locations.map((location: string) => (
          <li
            key={location}
            className={cx(styles.list__item, {
              [styles.disabled]: location === "Yogya",
            })}
          >
            <Link to={`${PUBLIC_URL}/${slugify(location)}`}>
              {location} {location === "Yogya" && "(Coming Soon)"}
            </Link>
          </li>
        ))}
        <li className={styles.list__item}>
          <Link to={`${PUBLIC_URL}/opeumbistro`}>Opeum Bistro</Link>
        </li>
        <li className={styles.list__item}>
          <Link to={`${PUBLIC_URL}/thecanopyspa`}>The Canopy Spa</Link>
        </li>
      </ul>
      {pages.map((item: { slug: string; name: string }) => (
        <Link
          key={item.slug}
          to={`${PUBLIC_URL}/${item.slug}`}
          className={styles.item}
        >
          {item.name}
        </Link>
      ))}
      <SocialIcons className={styles.social} containerClassName={styles.d} />
    </div>
  );
};

export default GlobalNav;
